import OriginFilter from '@/language/en/components/filter/OriginFilter';
import FieldFilter from '@/language/en/components/filter/FieldFilter';
import OperationFilter from '@/language/en/components/filter/OperationFilter';
import SortingFilter from '@/language/en/components/filter/SortingFilter';
import ComponentTypeFilter from '@/language/en/components/filter/ComponentTypeFilter';
import WidthFilter from '@/language/en/components/filter/WidthFilter';
import HeightFilter from '@/language/en/components/filter/HeightFilter';
import RepliedFilter from '@/language/en/components/filter/RepliedFilter';
import ChannelFilter from '@/language/en/components/filter/ChannelFilter';
import DarkPostFilter from '@/language/en/components/filter/DarkPostFilter';
import PageFilter from '@/language/en/components/filter/PageFilter';
import GenderFilter from '@/language/en/components/filter/GenderFilter';
import PolarityFilter from '@/language/en/components/filter/PolarityFilter';
import UserFilter from '@/language/en/components/filter/UserFilter';
import ContractFilter from '@/language/en/components/filter/ContractFilter';
import DomainsFilter from '@/language/en/components/filter/DomainsFilter';
import DeskTagsFilter from '@/language/en/components/filter/DeskTagsFilter';
import StatusFilter from '@/language/en/components/filter/StatusFilter';
import BotFilter from '@/language/en/components/filter/BotFilter';
import CheckedPosts from '@/language/en/components/filter/CheckedPosts';
import ScheduledFilter from '@/language/en/components/filter/ScheduledFilter';
import CampaignNameFilter from '@/language/en/components/filter/CampaignNameFilter';
import CategoryFilter from '@/language/en/components/filter/CategoryFilter';
import PostByIdFilter from '@/language/en/components/filter/PostByIdFilter';
import OperatorsFilter from '@/language/en/components/filter/OperatorsFilter';
import TeamsFilter from '@/language/en/components/filter/TeamsFilter';
import SacTypeFilter from '@/language/en/components/filter/SacTypeFilter';
import TagView from '@/language/en/components/filter/TagView';
import MultiSelectFilter from '@/language/en/components/filter/MultiSelectFilter';
import NegativationFilter from '@/language/en/components/filter/NegativationFilter';
import RepliersFilter from '@/language/en/components/filter/RepliersFilter';
import StudioMultiSelect from '@/language/en/components/filter/StudioMultiSelect';

export default {
  OriginFilter,
  FieldFilter,
  OperationFilter,
  SortingFilter,
  ComponentTypeFilter,
  WidthFilter,
  HeightFilter,
  RepliedFilter,
  ChannelFilter,
  DarkPostFilter,
  PageFilter,
  GenderFilter,
  PolarityFilter,
  UserFilter,
  ContractFilter,
  DomainsFilter,
  DeskTagsFilter,
  StatusFilter,
  BotFilter,
  CheckedPosts,
  ScheduledFilter,
  CampaignNameFilter,
  CategoryFilter,
  PostByIdFilter,
  OperatorsFilter,
  TeamsFilter,
  SacTypeFilter,
  TagView,
  MultiSelectFilter,
  NegativationFilter,
  RepliersFilter,
  StudioMultiSelect,
};
